import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Alert, Table, Button  } from 'reactstrap'
import { handleGraphQLErrors } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { GET_LOG_FILE_LIST_QUERY } from '../../graphql.js'

export const GET_LOG_FILE_LIST = gql(GET_LOG_FILE_LIST_QUERY)

export default function LogFileList(props) {
  console.log('LogFileList rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [logFileList, setlogFileList] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    async function fetchItems() {
      console.log('LogFileList.useEffect.fetchItems')
      try {
        setShowSpinner(true)
        const { data, errors } = await window.apolloClient.query({ query: GET_LOG_FILE_LIST })
        if (data.getLogFileList) {
          //console.log(data.getLogFileList)
          setlogFileList(data.getLogFileList)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchItems()
  }, [refresh])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (logFileList) {
    const rows = []
    for (let file of logFileList) {
      if (file.name.includes('.log')) {
        const fileInfo = { name: file.name, directory: file.directory, json: file.json }
        let path = `/logFile?fileInfo=${JSON.stringify(fileInfo)}`
        let viewButton = null
        if (file.size > 0) {
          viewButton = <Link to={path}><Button color="primary" size="sm">View</Button></Link>
        }
        rows.push(<tr key={file.name}><td>{viewButton}</td><td style={{ textAlign: 'left' }}>{file.name}</td><td style={{ textAlign: 'right'}}>{file.size}</td><td>{file.modified}</td></tr>)
      }
    }
    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <Button color="primary" style={{ marginBottom: '10px' }} onClick={() => setRefresh(refresh + 1)}>Refresh</Button>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Size</th>
                <th>Modified</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
